import React from 'react';

const GetStartedSection = () => {
    return (
        <section className="w-full lg:pb-24 pb-16 select-none">
            <div className="w-full max-w-[1248px] mx-auto min-h-[377px] relative flex flex-col justify-center overflow-hidden rounded-xs shadow-md">
                <div className="absolute inset-0 w-full h-full z-0">
                    <img
                        src="/assets/data/bg2.png"
                        alt="Blue operational fluid abstract rendering"
                        className="w-full h-full object-cover pointer-events-none"
                    />
                </div>
                <div className="w-full lg:w-[55%] p-8 sm:p-12 lg:p-16 flex flex-col justify-center text-left relative z-10">
                    <h2 className="text-[20px] sm:text-[30px] font-sora font-[600] text-white tracking-tight mb-4">
                        Get Started
                    </h2>

                    <p className="text-[14px] sm:text-[16px] font-graphik font-[500] text-gray-200 leading-relaxed max-w-[434px] mb-8">
                        Ready to see what your process data is really telling you? Talk to Mobikode about a process data audit, or find the deployment option that fits how your team works.
                    </p>

                    <div className="flex flex-wrap items-center gap-6">
                        <a
                            href="/contact"
                            className="text-[14px] sm:text-[16px] pb-[10px] border-b border-white font-graphik font-[500] text-white decoration-white flex items-center gap-[18px]"
                        >
                            Talk to an Expert
                            <img src="/assets/nav/white-logo.svg" alt="" />
                        </a>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default GetStartedSection;